<div class="main-home">
  <header>
    <mat-toolbar color="primary">
      <span>Fibonacci</span>
      <span>&nbsp;{{ authDomain }}</span>
      <span class="example-fill-remaining-space"></span>
      <button mat-button [matMenuTriggerFor]="menu">
        <mat-icon>person</mat-icon>&nbsp;{{ loggedUser }}
      </button>
      <mat-menu #menu="matMenu">
        <div *ngIf="loggedUser=='Anonymus'; then thenBlock; else elseBlock"></div>
        <ng-template #thenBlock>
          <button (click)="loginWithGoogle()" mat-menu-item>
            <mat-icon>flight_depa</mat-icon>
            <span>Login</span>
          </button>
        </ng-template>
        <ng-template #elseBlock>
          <button (click)="logoutWithFireBase()" mat-menu-item>
            <mat-icon>flight_land</mat-icon>
            <span>Logout</span>
          </button>
        </ng-template>
      </mat-menu>
    </mat-toolbar>
  </header>
  <main>

    <mat-card class="home-login">
      <mat-card-content>
        <img class="logo-extravega" src="/assets/img/extravega-logo.svg" alt="logo">
        <div class="home-control-container">
          <div *ngIf="!authCheck; else buttonsBlock">
            <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
          </div>
          <ng-template #buttonsBlock>
            <div *ngIf="!loggedUser || loggedUser=='Anonymus'; else loggedBlock" (click)="loginWithGoogle()" class="login-with-google">
              <img src="/assets/img/btn_google_signin_light_normal_web@2x.png" alt="">
            </div>
            <ng-template #loggedBlock>
              <button mat-raised-button (click)="enterTheApp()" i18n>Enter</button>
            </ng-template>
          </ng-template>
          <p class="loginError" *ngIf="isLoginError" i18n>Error while trying to login. Please try again</p>
        </div>
      </mat-card-content>
    </mat-card>
  </main>
</div>


// WEBPACK FOOTER //
// ./src/app/home/home.component.html